import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { dealerKitApi } from '@/lib/api/dealer-kit.api';
import { toSearchRequest } from '@/pages/dealer-kit/stock-search/search-state';

import type { StockSearchState } from '@repo/shared-types';

export const useStockSearch = (state: StockSearchState, page: number, sources: string[]) => {
  const request = toSearchRequest(state, page, sources);
  return useQuery({
    queryKey: ['stock-search', request],
    queryFn: () => dealerKitApi.searchStock(request),
    placeholderData: keepPreviousData,
    staleTime: 30_000,
  });
};
